


import React, { createContext, useState, useContext, useRef } from 'react';

const Mp3PlayerContext = createContext();

const Mp3PlayerProvider = ({ children }) => {

    const audioRef = useRef(null);
    const [isPlaying, setIsPlaying] = useState(false);
    const [toastDisplay, setToastDisplay] = useState(false);

    return (
        <Mp3PlayerContext.Provider
            value={{ isPlaying, setIsPlaying, toastDisplay, setToastDisplay, audioRef }}>
            {children}
        </Mp3PlayerContext.Provider>
    );
};

const useMp3Player = () => useContext(Mp3PlayerContext);

export { Mp3PlayerProvider, useMp3Player }



// setIsPlaying(prevState => !prevState);